import React from "react";
import PageTitle from "../PageTitle";
import { doRequest, imageURL } from "../../helper";
import $ from "jquery";

let newevent = [
  "sashaktnari",
  "swachhbharat",
  "promotingincredibleindia",
  "vocalforlocal",
  "digitalpayment",
  "videoreel",
  "media-coverage",
  "expandmoment",
];

export default class ViksitVbadashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      userid: "",
      page: 0,
      type: "",
      activity: "",
      username: "",
      loadMoreDisplay: false,
      limit: 10,
    };
    this.viksitbharatList = this.viksitbharatList.bind(this);
  }

  componentDidMount() {
    const { match } = this.props;
    const userid_param = match.params.status;
    // console.log(userid, "param");
    this.setState({
      userid: userid_param,
    });
    this.viksitbharatList(
      userid_param,
      this.state.type,
      this.state.activity,
      "loadmore",
      0
    );
  }
  loadMoreData = () => {
    this.setState({
      page: this.state.page + 1,
    });
    this.viksitbharatList(
      this.state.userid,
      this.state.type,
      this.state.activity,
      "loadmore",
      this.state.page + 1
    );
  };

  enterPressed = (event) => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      if (this.input1.value) {
        this.setState({
          userid: this.input1.value,
        });
        $("#loader").css({ display: "block" });
        this.viksitbharatList(this.input1.value, "");
        $("#loader").css({ display: "none" });
      }
    }
  };

  viksitbharatList = (userid, type, activity, loadmore, pageno) => {
    $("#loader").css({ display: "block" });
    var ref = this;
    ref.setState({
      type: type,
      activity: activity,
    });

    if (!loadmore) {
      ref.setState({ items: [], page: 0 });
    }

    var form = new FormData();
    form.append("action", "useractivitylist");
    form.append(
      "token",
      "92f5603df5ef0772e0b2dcf149c33e53333cc6bfe4ae91beca97196ed5a9ac4201885cff081adb53b9661503c2b3f88a5b7ffc050da02cf749e109cbaf2bac57b92027f897cbf923a5082c2975f484f435ecaf0246a248d2a92f8db5e693778fc63b1f8e2180b9c265f3b1ff0b0cf1cdbeeee7159c4583244e9ceae695ff62930e446b50b6b8d89f991e0224372f4e560d659c13e86220c1001e9436f8ec7ab4a15e2f6b1b7041619bebe7d26650105f63382dd8ecb86ab8642760cfc671cbd99b3d2556bdfe92d9926ae07a6a8a0ff9b8efc10ab9adc11ed4b08a19568e8d60755ff0b199812fae0fa7a2fbab631f80"
    );
    form.append("userid", userid ? userid : "");
    form.append("type", type ? type : "");
    form.append("vba_activity", activity ? activity : "");
    form.append("index", pageno || pageno == "0" ? pageno : this.state.page);
    var requestOptions = {
      method: "POST",
      body: form,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          result["_resultflag"] == "1" &&
          result["_resultflag"] == 1
        ) {
          try {
            if (loadmore) {
              ref.setState(
                {
                  items: [...ref.state.items, ...result.data],
                  username: result.data[0].user_name_display,
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            } else {
              ref.setState(
                {
                  items: result.data,
                  username: result.data[0].user_name_display,
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            }

            if (result.data.length.toString() >= this.state.limit) {
              ref.setState({
                loadMoreDisplay: true,
              });
            } else {
              ref.setState({
                loadMoreDisplay: false,
              });
            }
          } catch (ex) {
            ref.setState({
              loadMoreDisplay: false,
            });
            $("#loader").css({ display: "none" });
          }
        }
      })
      .catch((error) => console.log("error", error));
  };

  render() {
    var bread = "Viksit Bharat Ambassador / Dashboard";
    var items = this.state.items;

    return (
      <div>
        <PageTitle
          title="#Viksit Bharat Ambassador"
          bread={bread}
          Count={this.state.post_count}
        />
        <p
          style={{
            "text-align": "center",
            "font-weight": "bold",
            "margin-top": "10px",
          }}
        >
          Points for donation and expand moment will take around 1 hr to reflect
        </p>
        <div className="row row_date_div">
          <div
            style={{
              margin: "0px 0px 0px 76px",
            }}
          >
            <h4>Name : {this.state.username}</h4>
          </div>
          <div
            style={{
              margin: "0px 0px 0px 76px",
            }}
          >
            <select
              id="state"
              name="state"
              className="form-control rigt_mar"
              onChange={(e) =>
                this.viksitbharatList(
                  this.state.userid,
                  e.target.value,
                  "",
                  "",
                  0
                )
              }
              value={this.state.type}
            >
              <option value="">Select Your Activity</option>
              {Array.isArray(newevent) &&
                newevent.map((val, i) => {
                  return (
                    <option value={val} key={i}>
                      {val}
                    </option>
                  );
                })}
            </select>
          </div>
          <div
            style={{
              margin: "0px 0px 0px 76px",
            }}
          >
            <select
              id="state"
              name="state"
              className="form-control rigt_mar"
              onChange={(e) =>
                this.viksitbharatList(
                  this.state.userid,
                  "",
                  e.target.value,
                  "",
                  0
                )
              }
              value={this.state.activity}
            >
              <option value="">Select Your Type</option>
              <option value="week">Weekly</option>
              <option value="month">Monthly</option>
            </select>
          </div>

          <button
            style={{
              "border-radius": "20px",
              "margin-left": "10px",
            }}
            className="btn-success"
            onClick={() => {
              window.location.reload();
            }}
          >
            Clear filter
          </button>
        </div>

        <br />
        <hr style={{ margin: "0px", "border-top": "1px solid black" }} />
        <div className="wrapper wrapper-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <table className="table mt-5">
                  <thead className="thead-dark">
                    <tr>
                      <th>SNo.</th>
                      <th>Activity Performed</th>
                      <th>Points</th>
                      {/* <th>Date</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(items) &&
                      items.map((value, index) => {
                        let ind = index + 1;
                        return (
                          <tr>
                            <td>{ind}</td>
                            <td>{value.relation_type}</td>
                            <td>{value.point}</td>
                            {/* <td>{value.created_at}</td> */}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {this.state.loadMoreDisplay && (
            <button
              style={{
                position: "relative",
                margin: "0px auto 20px auto",
                display: "block",
                padding: "10px 18px",
              }}
              type="button"
              onClick={this.loadMoreData}
            >
              Load More
            </button>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/ViksitBharat/ViksitVbadashboard.jsx